import { useMutation, useQueryClient } from "@tanstack/react-query";
import { post } from "./client";

export function useAction(path: string) {
  const client = useQueryClient();
  return useMutation({ mutationFn: (body: Record<string, unknown>) => post<unknown>(path, body), onSuccess: () => void client.invalidateQueries() });
}
